<template>
  <div class="new-content-page">
    <b-container class="mt-5 position-relative">
      <b-row class="mt-4">
        <b-col md="8" offset-md="2">
          <div class="editor-wrap bg-white p-5 shadow-sm" id="econtent"></div>
        </b-col>
      </b-row>

      <b-row class="my-5">
        <b-col md="6" offset-md="3" class="d-flex justify-content-center">
          <canvas class="shadow" id="ecanvas" width="500" height="500"></canvas>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// eslint-disable-next-line
import { fabric } from 'fabric'; // Needed for server canvas rendering
window.fabric = fabric;

import fonts from '~/assets/fonts';
import WebFont from 'webfontloader';
import { staticPublicPrefix } from '~/utils/helpers.js';

export default {
  name: 'SrView',

  created() {
    WebFont.load({
      google: {
        families: fonts.filter(font => font.type === 'google').map(font => font.fontFamily),
      },
      custom: {
        families: fonts.filter(font => font.type === 'custom').map(font => font.fontFamily),
        urls: [`${staticPublicPrefix}assets/fonts/faces.css`],
      },
      active: () => {
        // All fonts are loaded
      },
    });
  },

  async mounted() {
    window.fabric = fabric;

    /*
    const data = JSON.parse(
      `{"version":"4.5.0","objects":[{"type":"image","version":"4.5.0","originX":"left","originY":"top","left":0,"top":0,"width":500,"height":500,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"cropX":0,"cropY":0,"src":"http://localhost:8000/designs/frames/frame-1.png","crossOrigin":null,"filters":[]},{"type":"textbox","version":"4.5.0","originX":"center","originY":"center","left":250,"top":215,"width":320,"height":91.53,"fill":"#262628","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"text":"Add some text here","fontSize":45,"fontWeight":"normal","fontFamily":"Archivo Black","fontStyle":"normal","lineHeight":0.8,"underline":false,"overline":false,"linethrough":false,"textAlign":"center","textBackgroundColor":"","charSpacing":0,"path":null,"direction":"ltr","minWidth":20,"splitByGrapheme":false,"styles":{}}],"background":"#fff","backgroundImage":{"type":"image","version":"4.5.0","originX":"left","originY":"top","left":-125,"top":0,"width":1080,"height":720,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":0.6944444444,"scaleY":0.6944444444,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"cropX":0,"cropY":0,"src":"https://images.unsplash.com/photo-1620983379290-71e02d8ca563?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=Mnw5NjkwNHwwfDF8cmFuZG9tfHx8fHx8fHx8MTYyMzA4NjAyNA&ixlib=rb-1.2.1&q=80&w=1080","crossOrigin":null,"filters":[]}}
`,
    );

    const canvas = new fabric.Canvas('ecanvas');

    const waitForSVGLoad = () =>
      new Promise((resolve, reject) => {
        try {
          canvas.renderAll.bind(canvas);
          const res = canvas.loadFromJSON(data, () => {
            resolve(1);
          });

          if (!res) reject(0);
        } catch (e) {
          reject(0);
        }
      });

    const response = await waitForSVGLoad();
    console.log(canvas, response);

    */
  },

  beforeDestroy() {
    window.fabric = null;
  },
};
</script>

<style lang="scss">
@import '~@/scss/content-formating';

.editor-wrap {
  min-height: 150vh;
}
</style>
